import { Tab, Tabs } from '@mui/material';
import { FlowHumanTaskType } from 'flow-schema';
import { useState } from 'react';

import { HumanTaskGeneralFormFields } from './GeneralTab/FormFields';
import { SubmitPriorAuthorizationFormFields } from './PriorAuthorization/FormFields';
import { HumanTaskSteps } from './Steps/Steps';
import { HumanTaskToolsFormFields } from './ToolsTab/FormFields';
import { HumanTaskWorkContextTabs } from './WorkContexts/WorkContextTabs';

enum HumanTaskStandardTab {
  Task = 'Task',
  Tools = 'Tools',
  Reference = 'Reference',
  Settings = 'Settings',
}

interface HumanTaskStandardTabsProps {
  taskType:
    FlowHumanTaskType.CustomSubtask | FlowHumanTaskType.SubmitPriorAuthorization | undefined;
}

export function HumanTaskStandardTabs(props: HumanTaskStandardTabsProps) {
  const { taskType } = props;
  const [selectedTab, setSelectedTab] = useState<HumanTaskStandardTab>(HumanTaskStandardTab.Task);

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={(_event, newTab) => {
          setSelectedTab(newTab);
        }}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tab label="Task" value={HumanTaskStandardTab.Task} />
        <Tab label="Tools" value={HumanTaskStandardTab.Tools} />
        <Tab label="Reference" value={HumanTaskStandardTab.Reference} />
        <Tab label="Settings" value={HumanTaskStandardTab.Settings} />
      </Tabs>
      {/* Older block versions omit taskType and use custom task fields. */}
      {selectedTab === HumanTaskStandardTab.Task &&
        (taskType === FlowHumanTaskType.SubmitPriorAuthorization ? (
          <SubmitPriorAuthorizationFormFields />
        ) : (
          <HumanTaskSteps />
        ))}
      {selectedTab === HumanTaskStandardTab.Tools && <HumanTaskToolsFormFields />}
      {selectedTab === HumanTaskStandardTab.Reference && <HumanTaskWorkContextTabs />}
      {selectedTab === HumanTaskStandardTab.Settings && <HumanTaskGeneralFormFields />}
    </>
  );
}
